import { render } from "./OrderersSync.vue?vue&type=template&id=2573c5a8&scoped=true"
import script from "./OrderersSync.vue?vue&type=script&lang=js"
export * from "./OrderersSync.vue?vue&type=script&lang=js"

import "./OrderersSync.vue?vue&type=style&index=0&id=2573c5a8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2573c5a8"]])

export default __exports__